import React from "react";
import "../App.css";

function Privacy() {
  return (
    <div className="page">
      <div className="page-content">
        <div className="legal-page">
          <h1>Politique de Confidentialité</h1>
          <p className="legal-date">Dernière mise à jour : avril 2026</p>

          <section>
            <h2>1. Responsable du traitement</h2>
            <p>
              L'application GymNote est éditée par Mathis Le Berrigaud, développeur
              indépendant (ci-après « nous » ou « GymNote »).<br />
              Contact : <a href="mailto:contact@gymnote.fr">contact@gymnote.fr</a><br />
              Site web : <a href="https://gymnote.fr">gymnote.fr</a>
            </p>
          </section>

          <section>
            <h2>2. Données collectées et finalités</h2>

            <h3>2.1 Données de compte</h3>
            <p>
              Lors de la création d'un compte, nous collectons : prénom, nom, adresse
              e-mail et mot de passe (stocké de façon chiffrée, jamais en clair). Ces
              données sont nécessaires à l'authentification et à la synchronisation de
              vos données entre vos appareils.
            </p>
            <p>
              Si vous utilisez la connexion via <strong>Google Sign-In</strong> ou{" "}
              <strong>Sign in with Apple</strong>, nous recevons uniquement votre
              prénom, nom et adresse e-mail depuis ces services. Nous ne stockons pas
              vos mots de passe Google ou Apple. Consultez les politiques de
              confidentialité de{" "}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Google</a>{" "}
              et d'<a href="https://www.apple.com/fr/legal/privacy/" target="_blank" rel="noreferrer">Apple</a>{" "}
              pour en savoir plus sur leur traitement des données.
            </p>

            <h3>2.2 Données sportives et de performance</h3>
            <p>
              L'application enregistre vos données d'entraînement : séances, exercices,
              séries (poids, répétitions, RPE), notes, modèles d'entraînement, mensurations
              corporelles (poids, tour de taille, etc.) et statistiques de progression.
              Ces données sont stockées localement sur votre appareil et, si vous êtes
              connecté, synchronisées sur nos serveurs afin d'être accessibles depuis
              plusieurs appareils.
            </p>

            <h3>2.3 Données sociales</h3>
            <p>
              Si vous utilisez les fonctionnalités sociales, les informations suivantes
              sont partagées avec vos amis GymNote :
            </p>
            <ul>
              <li>Vos progressions et records personnels récents (séries sélectionnées)</li>
              <li>Votre prénom et nom (pour identification)</li>
            </ul>
            <p>
              Vous pouvez laisser des <strong>réactions</strong> (👏 bravo, 🔥 feu, 💪
              force) et des <strong>commentaires</strong> sur les séries de vos amis.
              Ces interactions sont visibles par l'ensemble de vos amis GymNote et par
              le propriétaire de la série. Le texte de vos commentaires et votre identité
              sont stockés dans notre base de données.
            </p>
            <p>
              Les données sociales ne sont partagées qu'avec les utilisateurs que vous
              avez acceptés comme amis via un code d'invitation. Vous pouvez supprimer
              vos propres commentaires à tout moment depuis l'application.
            </p>

            <h3>2.4 Signalements de contenu</h3>
            <p>
              Si vous signalez un commentaire inapproprié via la fonction de signalement,
              nous enregistrons : l'identifiant de l'interaction signalée, votre
              identifiant utilisateur et la date du signalement. Ces données sont
              utilisées exclusivement à des fins de modération par notre équipe et ne
              sont jamais partagées avec d'autres utilisateurs. Les signalements sont
              conservés pendant 12 mois.
            </p>

            <h3>2.5 Relation coach / élève</h3>
            <p>
              Si vous êtes en relation de coaching, votre coach a accès à vos données
              d'entraînement (séances, exercices, séries, progressions) afin de vous
              accompagner. Cette relation est établie sur votre initiative via un code
              d'invitation. Vous pouvez y mettre fin à tout moment depuis l'application.
            </p>

            <h3>2.6 Données de paiement et d'abonnement</h3>
            <p>
              Les paiements sont traités par <strong>Stripe</strong>, certifié PCI-DSS
              niveau 1. GymNote ne stocke jamais vos coordonnées bancaires. Nous
              conservons uniquement un identifiant client Stripe, l'identifiant
              d'abonnement, le montant, la date et le statut de paiement à des fins de
              gestion commerciale et comptable. Consultez la{" "}
              <a href="https://stripe.com/fr/privacy" target="_blank" rel="noreferrer">
                politique de confidentialité de Stripe
              </a>
              .
            </p>
            <p>
              La gestion des abonnements in-app (iOS et Android) est également assurée
              par <strong>RevenueCat</strong>. Consultez la{" "}
              <a href="https://www.revenuecat.com/privacy" target="_blank" rel="noreferrer">
                politique de confidentialité de RevenueCat
              </a>
              .
            </p>

            <h3>2.7 Notifications push</h3>
            <p>
              Si vous autorisez les notifications, nous enregistrons un token de
              notification (identifiant technique de votre appareil) afin de vous envoyer
              des alertes liées à l'activité de vos amis (réactions, commentaires). Vous
              pouvez désactiver les notifications à tout moment depuis les paramètres de
              votre appareil. Les tokens sont supprimés lors de la déconnexion ou de la
              suppression de votre compte.
            </p>

            <h3>2.8 Données techniques et logs</h3>
            <p>
              Nous collectons des données techniques anonymisées en cas d'erreur de
              synchronisation (nature de l'erreur, données de contexte) afin d'améliorer
              la fiabilité de l'application. Ces données ne permettent pas de vous
              identifier directement.
            </p>
          </section>

          <section>
            <h2>3. Base légale des traitements</h2>
            <ul>
              <li>
                <strong>Exécution du contrat</strong> : synchronisation des données,
                gestion du compte, fonctionnalités de l'application.
              </li>
              <li>
                <strong>Intérêt légitime</strong> : modération du contenu, prévention
                des abus, amélioration de la stabilité technique.
              </li>
              <li>
                <strong>Consentement</strong> : notifications push, fonctionnalités
                sociales optionnelles.
              </li>
              <li>
                <strong>Obligation légale</strong> : facturation, conservation des
                données comptables.
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Hébergement et transfert de données</h2>
            <p>
              Vos données sont hébergées par <strong>IONOS</strong> sur des serveurs
              situés en France (Union européenne). Aucun transfert de vos données vers
              des pays hors UE n'est effectué, sauf pour les services tiers mentionnés
              (Stripe, Google, Apple, RevenueCat) qui disposent de garanties adéquates
              (clauses contractuelles types, Privacy Shield ou décision d'adéquation).
            </p>
          </section>

          <section>
            <h2>5. Durée de conservation</h2>
            <ul>
              <li><strong>Données de compte et sportives</strong> : conservées tant que votre compte est actif, puis supprimées dans les 30 jours suivant la suppression du compte.</li>
              <li><strong>Commentaires et réactions</strong> : supprimés sur votre demande ou lors de la suppression de votre compte.</li>
              <li><strong>Signalements de contenu</strong> : 12 mois.</li>
              <li><strong>Données de facturation</strong> : 10 ans (obligation légale).</li>
              <li><strong>Logs d'erreurs techniques</strong> : 6 mois.</li>
              <li><strong>Tokens de notification</strong> : supprimés à la déconnexion ou suppression du compte.</li>
            </ul>
          </section>

          <section>
            <h2>6. Partage des données</h2>
            <p>Nous ne vendons jamais vos données personnelles. Les seuls destinataires sont :</p>
            <ul>
              <li><strong>Stripe</strong> : traitement des paiements.</li>
              <li><strong>RevenueCat</strong> : gestion des abonnements in-app.</li>
              <li><strong>IONOS</strong> : hébergement de la base de données.</li>
              <li><strong>Google / Apple</strong> : authentification si vous utilisez ces services.</li>
              <li><strong>Expo / Firebase</strong> : envoi des notifications push.</li>
              <li><strong>Vos amis GymNote</strong> : données sociales limitées (voir §2.3).</li>
              <li><strong>Votre coach</strong> : données d'entraînement si relation de coaching active.</li>
            </ul>
          </section>

          <section>
            <h2>7. Sécurité</h2>
            <p>
              Les mots de passe sont hachés (bcrypt). Les communications entre
              l'application et nos serveurs sont chiffrées via HTTPS/TLS. L'accès
              à l'API est sécurisé par une clé API et des jetons d'authentification JWT.
              Les données sensibles sur l'appareil sont stockées dans le trousseau
              sécurisé (iOS Keychain / Android Keystore) via expo-secure-store.
            </p>
          </section>

          <section>
            <h2>8. Vos droits</h2>
            <p>
              Conformément au RGPD, vous disposez des droits suivants, exerçables en
              écrivant à{" "}
              <a href="mailto:contact@gymnote.fr">contact@gymnote.fr</a> :
            </p>
            <ul>
              <li><strong>Droit d'accès</strong> : obtenir une copie de vos données.</li>
              <li><strong>Droit de rectification</strong> : corriger vos données inexactes.</li>
              <li><strong>Droit à l'effacement</strong> : supprimer votre compte et vos données depuis l'application (Profil → Compte → Supprimer mon compte).</li>
              <li><strong>Droit à la portabilité</strong> : exporter vos données via la fonction d'export de l'application.</li>
              <li><strong>Droit d'opposition</strong> : vous opposer au traitement pour motif légitime.</li>
              <li><strong>Droit à la limitation</strong> : limiter le traitement de vos données dans certains cas.</li>
            </ul>
            <p>
              Vous pouvez également introduire une réclamation auprès de la{" "}
              <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">CNIL</a>.
            </p>
          </section>

          <section>
            <h2>9. Cookies et traceurs</h2>
            <p>
              L'application mobile GymNote n'utilise pas de cookies. Le site web
              gymnote.fr utilise uniquement des cookies techniques strictement nécessaires
              au fonctionnement du site (session d'authentification). Aucun cookie
              publicitaire ou de tracking tiers n'est utilisé.
            </p>
          </section>

          <section>
            <h2>10. Modifications</h2>
            <p>
              Nous nous réservons le droit de modifier cette politique à tout moment.
              Toute modification substantielle vous sera notifiée par notification dans
              l'application. La date de dernière mise à jour figure en haut de cette page.
            </p>
          </section>

          <section>
            <h2>11. Contact</h2>
            <p>
              Pour toute question relative à vos données personnelles :{" "}
              <a href="mailto:contact@gymnote.fr">contact@gymnote.fr</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
